import styled from "styled-components";

export const WhatWeDoSection = styled.section`
  padding: 4rem 0 5rem;
`;

export const WhatWeDoGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  align-items: start;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

export const WhatWeDoCopy = styled.div`
  position: relative;
  padding: 2rem 0;

  &::before {
    content: "";
    position: absolute;
    left: -2rem;
    top: 0;
    width: 280px;
    height: 280px;
    border-radius: 50%;
    background: radial-gradient(
      circle,
      rgba(74, 147, 207, 0.2) 0%,
      transparent 70%
    );
    z-index: -1;
  }

  .eyebrow {
    font-family: "SatoshiRegular", sans-serif;
    font-size: 0.95rem;
    color: #666;
    margin-bottom: 0.75rem;
  }

  h2 {
    font-family: "SatoshiBold", sans-serif;
    font-size: clamp(1.75rem, 3vw, 2.35rem);
    line-height: 1.2;
    color: ${(props) => props.theme.colors.balck_200};
    margin-bottom: 1rem;
    font-weight: 700;
  }

  .subtitle {
    font-family: "SatoshiRegular", sans-serif;
    font-size: 1rem;
    line-height: 1.6;
    color: #555;
    max-width: 28rem;
  }
`;

export const BenefitCards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

export const BenefitCard = styled.article`
  display: flex;
  gap: 1rem;
  padding: 1.5rem;
  background: ${(props) => props.theme.colors.white_100};
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06);
  border: 1px solid #f0f0f0;

  .icon {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    flex-shrink: 0;
    background: linear-gradient(
      135deg,
      ${(props) => props.theme.colors.purple_100} 0%,
      #7eb8e8 100%
    );
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 1.1rem;
  }

  h3 {
    font-family: "SatoshiBold", sans-serif;
    font-size: 1rem;
    margin: 0 0 0.5rem;
    color: ${(props) => props.theme.colors.balck_200};
    line-height: 1.35;
  }

  p {
    font-family: "SatoshiRegular", sans-serif;
    font-size: 0.9rem;
    line-height: 1.55;
    color: #666;
    margin: 0;
  }
`;
